import { ICreateCustomStudentQuiz } from '@sdk/contracts';
import { useMutation } from '@tanstack/react-query';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useQuizInfo } from '@/hooks';
import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useCreateCustomStudentQuiz = () => {
  const { t } = useTranslation('StudentQuizzesTranslations');
  const navigateTo = useNavigate();
  const { setStudentQuiz } = useQuizInfo();

  const { mutateAsync: createCustomStudentQuiz, isPending: isWorking } = useMutation({
    mutationFn: (values: ICreateCustomStudentQuiz) => QuizService.createCustomStudentQuiz(values),
    onSuccess: studentQuiz => {
      if (studentQuiz.studentQuestions.length === 0) {
        Modal.error({
          centered: true,
          title: t('FREE_QUESTIONS_ERROR_TITLE'),
          content: t('FREE_QUESTIONS_ERROR_CONTENT'),
          onOk: () => window.location.reload()
        });
      }
      setStudentQuiz(studentQuiz);
      navigateTo(`/tests/${studentQuiz._id}`);
    },
    onError: () => {
      Modal.error({
        centered: true,
        title: t('FREE_QUESTIONS_ERROR_TITLE'),
        content: t('FREE_QUESTIONS_ERROR_CONTENT'),
        onOk: () => window.location.reload()
      });
    }
  });

  const { mutateAsync: addNextLightningQuestion, isPending: isAddingNextLightningQuestion } =
    useMutation({
      mutationFn: (studentQuizId: string) => QuizService.addNextLightningQuestion(studentQuizId),
      onError: () => {
        Modal.error({
          centered: true,
          title: t('FREE_QUESTIONS_ERROR_TITLE'),
          content: t('FREE_QUESTIONS_ERROR_CONTENT')
        });
      }
    });

  return {
    isWorking,
    createCustomStudentQuiz,
    addNextLightningQuestion,
    isAddingNextLightningQuestion
  };
};
